import { Deserializable, Deserialize } from "../helpers/serialization";
import { Sprite } from "./sprite";
import { Point } from "./geometry";

export class ZoomImageTile extends Deserializable
{
    @Deserialize()
    public file: string;

    @Deserialize()
    public index: number;

    @Deserialize()
    public margin: boolean = false;
    
    @Deserialize()
    public u: number;
    
    @Deserialize()
    public v: number;
    
    @Deserialize()
    public uw: number;
    
    @Deserialize()
    public vh: number;
    
    @Deserialize()
    public width: number;
    
    @Deserialize()
    public height: number;
    
    @Deserialize({isArray:true})
    public descriptor: number[];

    public row:number;
    public col:number;
    public sprite:Sprite;

    public hideAfter:number = 0;

    /**
     * Checks if the tile's screen rectangle contains the given screen point
     * @param pos 
     */
    public contains(pos:Point):boolean
    {
        if (this.sprite)
            return this.sprite.rect.rect.contains(pos);
        else
            return false;            
    }

}